import remote from "../../../../services/remote";
import {
    getCasesSuccess,
    getCasesFailure,
    changeCaseStatusSuccess,
    changeCaseStatusFailure,
    getCaseFailure,
    getCaseSuccess
} from "./actions";
import {GET_CASES_REQUEST, CHANGE_CASE_STATUS_REQUEST, GET_CASE_DETAILS_REQUEST} from "./constants";
import {call, put, takeLatest} from "redux-saga/effects";
import SentryManager from "../../../../monitoring/Sentry";

function* getCases (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/bookings/get-bookings/${action.data.page}`,
            method: 'post',
            body: JSON.stringify({filterOptions: action.data.filterOptions, sortingOptions: action.data.sortingOptions})
        });
        if (response.success) {
            yield put(getCasesSuccess(response.data));
        } else {
            yield put(getCasesFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* changeCaseStatus (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/bookings/change-booking-status',
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(changeCaseStatusSuccess(response.data));
        } else {
            yield put(changeCaseStatusFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getCaseDetails (action) {
    const url = `/bookings/get-booking/${action.caseId}`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'get'
        });
        if (response.success) {
            yield put(getCaseSuccess(response.data));
        } else {
            yield put(getCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchAdminCases() {
    yield takeLatest(GET_CASES_REQUEST , getCases);
    yield takeLatest(CHANGE_CASE_STATUS_REQUEST , changeCaseStatus);
    yield takeLatest(GET_CASE_DETAILS_REQUEST , getCaseDetails);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AllCases/saga.js